/**
 * @since 0.1.1
 */
import { z } from 'zod';

/**
 * @category detachSchema
 * @since 0.1.1
 */
export const detachSchema = z.record(z.any());
